"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setToken = exports.token = exports.TokenProvider = void 0;
var TokenProvider_1 = require("./components/TokenProvider");
Object.defineProperty(exports, "TokenProvider", { enumerable: true, get: function () { return __importDefault(TokenProvider_1).default; } });
var helpers_1 = require("./helpers");
Object.defineProperty(exports, "token", { enumerable: true, get: function () { return helpers_1.token; } });
Object.defineProperty(exports, "setToken", { enumerable: true, get: function () { return helpers_1.setToken; } });
